import type { InterventionTemplateLabelProps } from "./intervention-template-label.type";

import { useTranslation } from "react-i18next";

import { FlexContainerJsx } from "@/modules/flex-container";
import { InterventionTemplateLink } from "@/modules/intervention-template/intervention-template-link";

export const InterventionTemplateLabel = ({
  template,
  fallback,
}: InterventionTemplateLabelProps) => {
  const { t } = useTranslation();

  return (
    <FlexContainerJsx
      value={
        template ? (
          <InterventionTemplateLink template={template} showState showVersion />
        ) : (
          fallback
        )
      }
      label={t("intervention:form.template.label")}
      noWrapper
    />
  );
};
